import { I18nService } from '../../i18n/I18nService';
import { I18N_KEYS } from '../../i18n/keys';
import { FocusTrap } from '../../accessibility/FocusTrap';

export class KeyboardHelpModal {
  private i18n: I18nService;
  private focusTrap: FocusTrap;
  private dialog: HTMLDialogElement | null = null;

  constructor(i18n: I18nService, focusTrap: FocusTrap) {
    this.i18n = i18n;
    this.focusTrap = focusTrap;
  }

  render(): void {
    this.dialog = document.getElementById('keyboard-help-modal') as HTMLDialogElement;
    if (!this.dialog) {
      this.dialog = document.createElement('dialog');
      this.dialog.id = 'keyboard-help-modal';
      this.dialog.className = 'modal modal--keyboard-help';
      document.body.appendChild(this.dialog);
    }
  }

  open(): void {
    if (!this.dialog) this.render();

    const shortcuts = [
      { key: 'N / Space', desc: this.i18n.t(I18N_KEYS.KEYBOARD_NEXT) },
      { key: 'A', desc: this.i18n.t(I18N_KEYS.KEYBOARD_AUTOPLAY) },
      { key: 'S', desc: this.i18n.t(I18N_KEYS.KEYBOARD_SETTINGS) },
      { key: 'R', desc: this.i18n.t(I18N_KEYS.KEYBOARD_RESET) },
      { key: 'Esc', desc: this.i18n.t(I18N_KEYS.KEYBOARD_CLOSE) },
      { key: '?', desc: this.i18n.t(I18N_KEYS.KEYBOARD_HELP) },
    ];

    const rows = shortcuts.map(s => `<tr><td><kbd>${s.key}</kbd></td><td>${s.desc}</td></tr>`).join('');

    this.dialog!.innerHTML = `
      <div class="modal__content">
        <div class="modal__header">
          <h2>${this.i18n.t(I18N_KEYS.KEYBOARD_TITLE)}</h2>
          <button class="modal__close-btn" type="button" aria-label="Close">&times;</button>
        </div>
        <div class="modal__body">
          <table class="keyboard-help__table">
            <tbody>${rows}</tbody>
          </table>
        </div>
      </div>
    `;

    this.dialog!.querySelector('.modal__close-btn')?.addEventListener('click', () => this.close());

    this.dialog!.showModal();
    this.focusTrap.activate(this.dialog!);
  }

  close(): void {
    this.focusTrap.deactivate();
    if (this.dialog?.open) {
      this.dialog.close();
    }
  }

  isOpen(): boolean {
    return this.dialog?.open === true;
  }
}
